import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./footer.module.css";
import Link from "next/link";
import React from "react";
import BackToTop from "../backToTop";
import useTranslation from "next-translate/useTranslation";

var Footer = function Footer(_ref) {
  var hasBackToTop = _ref.hasBackToTop;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [hasBackToTop && /*#__PURE__*/_jsx(BackToTop, {}), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      style: {
        direction: isRTL ? "rtl" : "ltr"
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.footer,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.nav,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.column1,
            style: {
              textAlign: isRTL ? "right" : "left",
              padding: isRTL ? "0 30px 0 0" : "0 0 0 30px"
            },
            children: [/*#__PURE__*/_jsx(Link, {
              href: "/",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-home')
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: "/wow-stories",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-wowStories')
              })
            }), /*#__PURE__*/_jsx("a", {
              className: styles.navItem,
              target: "_blank",
              href: "https://wowmagazine.ir/",
              children: t('navbar:footer-wowMagazine')
            }), /*#__PURE__*/_jsx(Link, {
              href: "/contact-us",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-contactUs')
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: "/about-us",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-aboutUs')
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.column2,
            style: {
              textAlign: isRTL ? "right" : "left",
              padding: isRTL ? "0 30px 0 0" : "0 0 0 30px"
            },
            children: [/*#__PURE__*/_jsx(Link, {
              href: "/top-users",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-topUsers')
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: "/score",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-rules')
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: "/start",
              children: /*#__PURE__*/_jsx("a", {
                className: styles.navItem,
                children: t('navbar:footer-start')
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "".concat(styles.socialLinks, " ").concat(isRTL ? styles.socialLinksFa : ''),
              style: {
                flexDirection: isRTL ? "row-reverse" : ""
              },
              children: [/*#__PURE__*/_jsx("a", {
                className: "".concat(styles.navSocial, " ").concat(isRTL ? "pr-3 pl-3" : ""),
                target: "_blank",
                href: "https://www.instagram.com/wow.kanoon.ir/",
                children: /*#__PURE__*/_jsx("img", {
                  src: "/images/footer/Instagram Icon.png",
                  alt: ""
                })
              }), /*#__PURE__*/_jsx("a", {
                className: "".concat(styles.navSocial, " ").concat(isRTL ? "" : "pl-3"),
                target: "_blank",
                href: "https://t.me/en_kanoon",
                children: /*#__PURE__*/_jsx("img", {
                  src: "/images/footer/Telegram Icon.svg",
                  alt: ""
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: isRTL ? styles.logosFa : styles.logos,
          children: [/*#__PURE__*/_jsx(Link, {
            href: "/appFile/wow.apk",
            children: /*#__PURE__*/_jsx("a", {
              children: /*#__PURE__*/_jsx("img", {
                src: "/images/home/wow.png",
                className: "".concat(styles.logoBtn)
              })
            })
          }), /*#__PURE__*/_jsx("a", {
            target: "_blank",
            href: "https://cafebazaar.ir/app/com.wowDemo.wowApplication?l=en",
            children: /*#__PURE__*/_jsx("img", {
              src: "/images/home/bazaar.png",
              className: "".concat(styles.logoBtn, "  ")
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.socialLinksRight, " pr-3"),
            children: [/*#__PURE__*/_jsx("a", {
              className: "".concat(styles.navSocial, " pr-3"),
              target: "_blank",
              href: "https://www.instagram.com/wow.kanoon.ir/",
              children: /*#__PURE__*/_jsx("img", {
                src: "/images/footer/Instagram Icon.png",
                alt: ""
              })
            }), /*#__PURE__*/_jsx("a", {
              className: "".concat(styles.navSocial, " pr-3"),
              target: "_blank",
              href: "https://t.me/en_kanoon",
              children: /*#__PURE__*/_jsx("img", {
                src: "/images/footer/Telegram Icon.svg",
                alt: ""
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.footersFooter,
        children: [/*#__PURE__*/_jsx("p", {
          children: "Conditions of Use privacy notice"
        }), /*#__PURE__*/_jsx("p", {
          children: "World of Words (WOW)"
        }), /*#__PURE__*/_jsx("p", {
          children: "2007 - 2021, wow.kanoon.ir"
        })]
      })]
    })]
  });
};

export default Footer;